/* Shop filters — product type x application, composable and deep-linkable.
   Ported from the mockup's initShop(); the data now lives on each card (data-tags, data-apps, ...). */
(() => {
  const grid = document.querySelector('#shop-grid');
  if (!grid || !document.querySelector('[data-filter]')) return;
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const cards = $$('[data-card]', grid);
  const state = { tag: new Set(), app: new Set(), sort: 'featured' };
  const params = new URLSearchParams(location.search);
  params.getAll('tag').forEach(v => state.tag.add(v));
  params.getAll('app').forEach(v => state.app.add(v));

  const tagsOf = c => c.dataset.tags.split(' ');
  const appsOf = c => c.dataset.apps.split(',').filter(Boolean);
  const matches = c =>
    (!state.tag.size || tagsOf(c).some(t => state.tag.has(t))) &&
    (!state.app.size || appsOf(c).some(a => state.app.has(a)));
  const num = (c, k) => Number(c.dataset[k]);
  const order = new Map(cards.map((c, i) => [c, i]));
  const sorters = {
    featured: (a, b) => order.get(a) - order.get(b),
    'cacao-up': (a, b) => num(a, 'cacao') - num(b, 'cacao'),
    'cacao-down': (a, b) => (num(b, 'cacao') === 999 ? -1 : num(b, 'cacao')) - (num(a, 'cacao') === 999 ? -1 : num(a, 'cacao')),
    'price-up': (a, b) => num(a, 'price') - num(b, 'price'),
    'price-down': (a, b) => num(b, 'price') - num(a, 'price'),
    name: (a, b) => a.dataset.name.localeCompare(b.dataset.name)
  };

  /* counts on the chips */
  $$('[data-filter]').forEach(el => {
    const [kind, val] = el.dataset.filter.split(':');
    const n = cards.filter(c => (kind === 'tag' ? tagsOf(c) : appsOf(c)).includes(val)).length;
    const out = el.querySelector('.chip__count');
    if (out) out.textContent = n;
  });

  const draw = () => {
    const shown = cards.filter(matches).sort(sorters[state.sort]);
    cards.forEach(c => { c.hidden = !shown.includes(c); });
    shown.forEach(c => grid.append(c));
    document.querySelector('#shop-count').textContent = `${shown.length} of ${cards.length} products`;
    document.querySelector('#shop-live').textContent = `${shown.length} products match the current filters.`;
    document.querySelector('#shop-empty').hidden = shown.length > 0;
    $$('[data-filter]').forEach(el => {
      const [kind, val] = el.dataset.filter.split(':');
      el.setAttribute('aria-pressed', String(state[kind].has(val)));
    });
    document.querySelector('#shop-clear').hidden = !(state.tag.size || state.app.size);
    const q = new URLSearchParams();
    state.tag.forEach(v => q.append('tag', v));
    state.app.forEach(v => q.append('app', v));
    history.replaceState(null, '', q.toString() ? `?${q}` : location.pathname);
  };

  $$('[data-filter]').forEach(el => el.addEventListener('click', () => {
    const [kind, val] = el.dataset.filter.split(':');
    state[kind].has(val) ? state[kind].delete(val) : state[kind].add(val);
    draw();
  }));
  document.querySelector('#shop-clear')?.addEventListener('click', () => { state.tag.clear(); state.app.clear(); draw(); });
  document.querySelector('#shop-sort')?.addEventListener('change', e => { state.sort = e.target.value; draw(); });
  draw();
})();
